import { getCookieConsent } from './cookieConsent.js';

window.GA_MEASUREMENT_ID = ''; // TODO: set your Google Analytics measurement ID (e.g. 'G-XXXXXXXXXX')

let loaded = false;

function loadGoogleAnalytics() {
  if (loaded || !window.GA_MEASUREMENT_ID) {
    return;
  }
  loaded = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=' + window.GA_MEASUREMENT_ID;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', window.GA_MEASUREMENT_ID);
}

function applyConsent(consent) {
  if (consent && consent.analytics) {
    loadGoogleAnalytics();
  }
}

// Client-only : appelé une fois depuis client-entry.js après l'hydratation.
export function initAnalytics() {
  applyConsent(getCookieConsent());
  window.addEventListener('cookieconsentchange', (event) => {
    applyConsent(event.detail);
  });
}
